import { render, staticRenderFns } from "./TicketLogsView.vue?vue&type=template&id=af97512a&scoped=true&"
import script from "./TicketLogsView.vue?vue&type=script&lang=js&"
export * from "./TicketLogsView.vue?vue&type=script&lang=js&"
import style0 from "./TicketLogsView.vue?vue&type=style&index=0&id=af97512a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af97512a",
  null
  
)

export default component.exports